import { RecursoCampanhaFilter } from './recurso-campanha-filter';

export class RecursoCampanhaFilterStorage {
    filter: RecursoCampanhaFilter;
    filterValues: Map<string, any>;

    constructor(filter: RecursoCampanhaFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
